module.exports = __webpack_public_path__ + "static/img/09@2x.47625de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/09@2x.png
// module id = jI4x
// module chunks = 1